import { atom } from "recoil";

export const currentUserPermission = atom<string[]>({
  key: "currentUserPermission",
  default: [],
});
